const initialState = {
  counter: 0,
  preferences: {},
};

export default initialState;
